// Small shared utilities used across calculators.

export const round = (n, d = 1) => {
  if (!Number.isFinite(n)) return 0;
  const p = 10 ** d;
  return Math.round(n * p) / p;
};

export const kgToLb = (kg) => kg * 2.20462;
export const lbToKg = (lb) => lb / 2.20462;
export const cmToIn = (cm) => cm / 2.54;
export const inToCm = (inches) => inches * 2.54;
export const cmToM = (cm) => cm / 100;

// Convert a "feet/inches" pair to cm (returns 0 if invalid).
export const ftInToCm = (ft, inches) => {
  const f = Number(ft) || 0;
  const i = Number(inches) || 0;
  return (f * 12 + i) * 2.54;
};

// BMI category label
export const bmiCategory = (bmi) => {
  if (bmi < 18.5) return { label: "Underweight", tone: "warning" };
  if (bmi < 25) return { label: "Normal weight", tone: "good" };
  if (bmi < 30) return { label: "Overweight", tone: "warning" };
  return { label: "Obese", tone: "danger" };
};

export const parseNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// Format minutes as HH:MM:SS or MM:SS
export const formatDuration = (totalSeconds) => {
  const s = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
};

// Parse "MM:SS" or "HH:MM:SS" to total seconds
export const parseTime = (v) => {
  if (!v) return 0;
  const parts = v.split(":").map((p) => Number(p) || 0);
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  return parts[0] || 0;
};

// Add N days to a Date and return a new Date
export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const formatDate = (d) => {
  if (!(d instanceof Date) || isNaN(d)) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
};
